import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import notification from 'ant-design-vue/es/notification'
import { Modal, message } from 'ant-design-vue'
import { VueAxios } from './axios'
import { ACCESS_TOKEN, USER_INFO, ORG_INFO, ACCESS_STUID } from '@/store/mutation-types'
import { domainUrlTransForm } from '@/utils/util'

const qs = require('querystring')
// 创建 axios 实例
const baseUrl = domainUrlTransForm(process.env.VUE_APP_API_BASE_URL)
// const loginUrl = domainUrlTransForm(process.env.VUE_APP_API_LOGIN_URL)
const service = axios.create({
  baseURL: baseUrl, // api base_url
  // baseURL: 'http://192.168.1.41:18000', // api base_url
  // baseURL: 'http://172.17.120.172:8999', // api base_url
  // baseURL: 'http://123.60.33.202:8999', // api base_url
  timeout: 10000 // 请求超时时间
})

const err = error => {
  console.log('error', error.response)
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: '错误',
        description: data.message
      })
    }
    console.log('error11111', error.response.data)
    const search = qs.decode(location.search)
    if (!search.ignoreLogin) {
      if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
        // if (data.error === 'kicked_token') {
        notification.error({
          message: '错误',
          description: '你已被踢出，请重新登录'
        })
        if (token) {
          Vue.ls.remove(ACCESS_TOKEN)
          store.dispatch('logout').then(() => {
            window.location.reload()
            this.$store.dispatch('logout')
            // setTimeout(() => {
            //   window.location.reload()
            //   this.$store.dispatch('logout')
            // }, 100)
          })
        }
        // }
      }
    }

    if (error.response.status.toString().startsWith('50')) {
      // Modal.error({
      //   title: '错误!',
      //   content: data.msg || data.message || error.response.message || '也不说为啥开小差'
      // })
      message.error(data.msg || data.message || error.response.message || '也不说为啥开小差')
      return Promise.reject(error)
    }
    if (error.response.status === 404) {
      // Modal.error({
      //   title: '服务器没这个功能!',
      //   content: `${error.response.config.method}: ${data.path}`
      // })
      const reg = /.o$/
      if (reg.test(error.response.config.url)) {
        message.error('激活异常，请联系老师处理')
      } else {
        message.error(`${error.response.config.method}: ${data.path}`)
      }
      return Promise.reject(error)
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  if (!navigator.onLine) {
    message.error('网络异常，请重试')
    return
  }
  if (!['oauth/token'].includes(config.url)) {
    const token = Vue.ls.get(ACCESS_TOKEN)
    const stuId = Vue.ls.get(ACCESS_STUID)
    // console.log('token', Vue.ls.get(ACCESS_TOKEN))
    const code = Vue.ls.get('code')
    const oid = Vue.ls.get(ORG_INFO) ? Vue.ls.get(ORG_INFO).id : ''
    // config.headers['Access-Token'] = token
    // config.headers['Authorization'] = `Bearer ${token}`
    if (!(config.headers && config.headers.isClear)) {
      code && (config.headers['ocode'] = `${code}`)
      oid && (config.headers['oid'] = `${oid}`)
      token && (config.headers['Authorization'] = `Bearer ${token}`)
      config.headers['token'] = config.headers['token'] || `${token}`
      config.headers['stuId'] = `${stuId}`
      config.headers['device'] = 'web'
      config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json'
    } else {
      delete config.headers.isClear
    }
    // form表单提交
    if (config.headers['Content-Type'] !== 'application/json') {
      config.data = qs.stringify(config.data)
    }
    return config
  } else {
    config.baseURL = 'https://shejl.accfun.com/'
    const token = Vue.ls.get(ACCESS_TOKEN)
    // const code = Vue.ls.get('code')
    const stuId = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO).id : Vue.ls.get(ACCESS_STUID)
    if (!(config.headers && config.headers.isClear)) {
      config.headers['token'] = config.headers['token'] || `${token}`
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
      }
      // config.headers['ocode'] = `${code}`
      config.headers['stuId'] = `${stuId}`
      config.headers['device'] = 'mobile'
      config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json'
    } else {
      delete config.headers.isClear
    }
    // form表单提交
    if (config.headers['Content-Type'] !== 'application/json') {
      config.data = qs.stringify(config.data)
    }
    return config
  }
}, err)

// response interceptor
service.interceptors.response.use(response => {
  Vue.ls.remove('isObsRequest')
  // 特殊模块判断，强烈不建议纳入公共模块 或 长期规划至指定该状态
  const loginJudge = response.data.code === '0' && response.config.url.includes('/user/biz/student/pc/passLogin') || response.data.code === '0' && response.config.url.includes('/user/biz/student/pc/smsLogin')
  // const loginJudge = response.data.code === '0' && response.data.errorCode === '900005' || response.data.code === '0' && response.data.errorCode === '900004' || response.data.code === '0' && response.data.errorCode === '900003' || response.data.code === '0' && response.data.errorCode === '900002' || response.data.code === '0' && response.data.errorCode === '900001' || response.data.code === '0' && response.data.errorCode === '110001' || response.data.code === '0' && response.data.errorCode === '110002' || response.data.code === '0' && response.data.errorCode === '110004'
  if (loginJudge) {
    return Promise.resolve(response)
  } else if (response.data.code === '0') {
    Modal.warning({
      // title: '错误!',
      content: response.data.message || '也不说为啥开小差'
    })
    // message.warning(response.data.message || '也不说为啥开小差')
    //  message.error('激活异常，请联系老师处理')
    return Promise.reject(response.data)
  }
  // response.data的data存在，就返回其data属性，否则返回本身
  if (response.data.code === '1' || response.data.data) {
    return Promise.resolve(response.data.data)
  }
  return Promise.resolve(response.data)
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export { installer as VueAxios, service as axios }

// import Vue from 'vue'
// import axios from 'axios'
// import store from '@/store'
// import notification from 'ant-design-vue/es/notification'
// import { Modal } from 'ant-design-vue'
// import { VueAxios } from './axios'
// import { ACCESS_TOKEN, ACCESS_STUID } from '@/store/mutation-types'
// import { domainUrlTransForm } from '@/utils/util'

// const qs = require('querystring')
// // 创建 axios 实例
// const baseUrl = domainUrlTransForm(process.env.VUE_APP_API_BASE_URL)
// const service = axios.create({
//   baseURL: baseUrl, // api base_url
//   timeout: 6000 // 请求超时时间
// })

// const err = (error) => {
//   if (error.response) {
//     const data = error.response.data
//     const token = Vue.ls.get(ACCESS_TOKEN)
//     if (error.response.status === 403) {
//       notification.error({
//         message: 'Forbidden',
//         description: data.message
//       })
//     }
//     const search = qs.decode(location.search)
//     if (!search.ignoreLogin) {
//       if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
//         notification.error({
//           message: 'Unauthorized',
//           description: 'Authorization verification failed'
//         })
//         if (token) {
//           store.dispatch('Logout').then(() => {
//             setTimeout(() => {
//               window.location.reload()
//             }, 1500)
//           })
//         }
//       }
//     }

//     if (error.response.status.toString().startsWith('50')) {
//       Modal.error({
//         title: '错误!',
//         content: data.msg || data.message || error.response.message || '也不说为啥开小差'
//       })
//     }
//     if (error.response.status === 404) {
//       Modal.error({
//         title: '服务器没这个功能!',
//         content: `${error.response.config.method}: ${data.path}`
//       })
//     }
//   }
//   return Promise.reject(error)
// }

// // request interceptor
// service.interceptors.request.use(config => {
//   const token = Vue.ls.get(ACCESS_TOKEN)
//   const stuId = Vue.ls.get(ACCESS_STUID)
//   console.log('token', Vue.ls.get(ACCESS_TOKEN))
//   // config.headers['Access-Token'] = token
//   // config.headers['Authorization'] = `Bearer ${token}`
//   if (!(config.headers && config.headers.isClear)) {
//     config.headers['token'] = config.headers['token'] || `${token}`
//     config.headers['stuId'] = `${stuId}`
//     config.headers['device'] = 'mobile'
//     config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json'
//   } else {
//     delete config.headers.isClear
//   }
//   // form表单提交
//   if (config.headers['Content-Type'] !== 'application/json') {
//     config.data = qs.stringify(config.data)
//   }
//   return config
// }, err)

// // response interceptor
// service.interceptors.response.use((response) => {
//   Vue.ls.remove('isObsRequest')
//   if (response.data.code === '0') {
//     Modal.error({
//       title: '错误!',
//       content: response.data.message || '也不说为啥开小差'
//     })
//     return
//   }
//   if (response.data instanceof Array) {
//     return response.data
//   }
//   if (response.data.data || response.data.data == null) {
//     return response.data.data
//   }
//   return response.data
// }, err)

// const installer = {
//   vm: {},
//   install(Vue) {
//     Vue.use(VueAxios, service)
//   }
// }

// export {
//   installer as VueAxios,
//   service as axios
// }
